// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-divider[data-v-72b6e9f7]{padding-top:5px;margin:0 35px;border-top-width:2px;border-top-style:solid;border-top-color:#c3c2c7}", ""]);
// Exports
module.exports = exports;
